import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-exit",
  "use": "icon-exit-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-exit\"><defs><style type=\"text/css\"></style></defs><path d=\"M928 96v832H96V697.472h89.6v140.8h652.8V185.728H185.6V312.96H96V96h832zM423.808 374.4l227.52 121.408v53.76H96v-89.856h327.808v-85.248z\" p-id=\"2001\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol